// import { Fragment } from "react";
// import { Popover, Transition } from "@headlessui/react";
// import { MenuIcon, XIcon } from "@heroicons/react/outline";
// import { ChevronRightIcon } from "@heroicons/react/solid";
import {
  AnnotationIcon,
  GlobeAltIcon,
  LightningBoltIcon,
  MailIcon,
  ScaleIcon,
} from "@heroicons/react/outline";

/* This example requires Tailwind CSS v2.0+ */

const roadmapFeatures = [
  {
    id: 1,
    name: "Decentraland Design Files",
    description:
      "When 20% of Sky Castles are sold, the Sky Castles team will release Decentraland scene files for the Sky Castle.",
    iconLabel: "20%",
  },
  {
    id: 3,
    name: "360 video drop",
    description:
      "When 50% of the Sky Castles have been sold, we will release 360 pan videos of each minted castle.",
    iconLabel: "50%",
  },
  {
    id: 2,
    name: "Sky Castles Museum & Clubhouse in Decentraland",
    description:
      "When 80% of the Sky Castles have been sold, the Sky Castles team will purchase a plot in Decentraland and build a Sky Castle Museum & Clubhouse.",
    iconLabel: "80%",
  },
  {
    id: 4,
    name: "To Beyond!",
    description:
      "The Sky Castles team will continue to build on the Sky Castles ecosystem with future drops, features and metaverse integration.",
    iconLabel: "100%",
  },
];

export default function Roadmap() {
  return (
    <div className="py-10 bg-gray-50 overflow-hidden lg:py-20">
      <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
        <svg
          className="hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12"
          width={404}
          height={784}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className="text-gray-200"
                fill="currentColor"
              />
            </pattern>
          </defs>
          <rect
            width={404}
            height={784}
            fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
          />
        </svg>

        <div className="relative">
          <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            <a id="roadmap">Sky Castles of Decentraland Roadmap</a>
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-center text-xl text-gray-500 hidden">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus
            magnam voluptatum cupiditate veritatis in, accusamus quisquam.
          </p>
        </div>

        <div className="relative mt-8 lg:mt-16 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className="mt-10 -mx-4 relative lg:mt-0" aria-hidden="true">
            <svg
              className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden"
              width={784}
              height={404}
              fill="none"
              viewBox="0 0 784 404"
            >
              <defs>
                <pattern
                  id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={784}
                height={404}
                fill="url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
              />
            </svg>
            <img
              className="relative mx-auto"
              width={490}
              src={`${process.env.PUBLIC_URL}/35.jpg`}
              alt=""
            />
          </div>

          <div className="relative">
            <h3 className="text-3xl font-extrabold text-gray-900 tracking-tight sm:text-3xl">
              Sale Milestones:
            </h3>
            <p className="mt-3 text-lg text-gray-500"></p>

            <dl className="mt-10 space-y-10">
              {roadmapFeatures.map((item) => (
                <div key={item.id} className="relative">
                  <dt>
                    <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white font-bold">
                      {item.iconLabel}
                    </div>
                    <p className="ml-16 text-lg leading-6 font-medium text-gray-900">
                      {item.name}
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {item.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
